import { render, staticRenderFns } from "./monitor-carouse.vue?vue&type=template&id=47f60818&"
import script from "./monitor-carouse.vue?vue&type=script&lang=js&"
export * from "./monitor-carouse.vue?vue&type=script&lang=js&"
import style0 from "./monitor-carouse.vue?vue&type=style&index=0&id=47f60818&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports